import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './style.scss';

export default class ListHeader extends Component {

    render() {

        const { translations, selectableList } = this.props;

        return (
            <div>
                <div className={
                    classNames(styles.listHeader, 
                        selectableList && styles.selectableList)
                }>
                    <span>
                        {translations.title1}
                    </span>
                    <span>
                        {translations.title2}
                    </span>
                </div>
            </div>
        );
    }
}

PropTypes.propTypes = {
    translations: PropTypes.shape({
        title1: PropTypes.string.isRequired,
        title2: PropTypes.string.isRequired
    }).isRequired
};